export const EMPTY_LABEL = '--';
